"use client";

import NextLink from "next/link";

import { Text } from "@/components/ui/text";
import { Icon } from "@/components/ui/icon";

import { useSectionHeader, UseSectionHeaderProps } from "./use-section-header";

export type SectionHeaderProps = UseSectionHeaderProps;

function SectionHeader(props: SectionHeaderProps) {
  const {
    styles,
    data: { title, subtitle, description, link },
  } = useSectionHeader(props);

  return (
    <>
      {title && (
        <div className={styles.wrapper()}>
          <Text tag="h2" size="titleExtraLarge" className={styles.title()}>
            {title}
          </Text>
          <NextLink href={link}>
            <Icon name="link" className={styles.linkIcon()} />
          </NextLink>
        </div>
      )}
      {subtitle && (
        <Text tag="h3" size="titleMedium" className={styles.subtitle()}>
          {subtitle}
        </Text>
      )}
      {description && (
        <Text tag="p" size="bodyMedium" className={styles.description()}>
          {description}
        </Text>
      )}
    </>
  );
}

export default SectionHeader;
